// extracted by mini-css-extract-plugin
export default {"Wrapper":"ResourcesView_Wrapper__3joTD"};